<template>
  <div>
    <v-container>
      <v-row class="market-slider">
        <v-col cols="12" sm="2" md="2" class="ads">
          <!-- src="../../assets/images/ad-banner.png" -->
          <v-img
            src="../../assets/images/book.png"
            class="white--text align-end margin-bottom"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            height="240px"
          ></v-img>
          <v-divider></v-divider>
          <v-img
            src="../../assets/images/book.png"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            height="240px"
          ></v-img>
        </v-col>
        <v-col cols="12" sm="8">
          <v-carousel>
            <v-carousel-item
              v-for="(item, i) in items"
              :key="i"
              :src="item.src"
              style="height: 300px !important;"
            ></v-carousel-item>
          </v-carousel>
        </v-col>
        <v-col cols="12" sm="2" md="2" class="ads">
          <!-- src="../../assets/images/ad-banner.png" -->
          <v-img
            src="../../assets/images/book.png"
            class="white--text align-end margin-bottom"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            height="240px"
            ><span class="red white--text offer-label">50%</span></v-img
          >
          <v-divider></v-divider>
          <v-img
            src="../../assets/images/book.png"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            height="240px"
            ><span class="red white--text offer-label">50%</span></v-img
          >
        </v-col>
      </v-row>

      <v-row class="categories" v-if="categories.length > 0">
        <v-col cols="12" sm="12">
          <h2 class="main-color">{{ $t("Categories") }}</h2>
        </v-col>

        <v-col cols="12" sm="12">
          <v-chip-group active-class="primary--text" column>
            <v-chip
              v-for="(cat, index) in categories"
              :key="index"
              x-large
              :class="colorClasses[index % 5]"
              :to="'/market/categories/' + cat.id"
            >
              {{ cat.name }}
            </v-chip>
          </v-chip-group>
        </v-col>

        <!-- <v-col cols="12" sm="2" md="2">
          <div class="cat" to="/" :class="colorClasses[index % 6]">
            <router-link to="/market/categories" class="category-link">
              <p class="text-center">{{ cat.name }}</p>
            </router-link>
          </div>
        </v-col> -->
      </v-row>

      <!-- =========================most sale items=====================  -->
      <v-row class="products offers">
        <v-col cols="6" sm="6">
          <h2 class="main-color">{{ $t("Offers") }}</h2>
        </v-col>
        <v-col cols="6" sm="6">
          <p
            class="watchAll grey--text"
            :class="locale == 'en' ? 'text-right' : 'text-left'"
          >
            <router-link to="/market/offers" class="nav-link">
              {{ $t("watchAll") }}
            </router-link>
          </p>
        </v-col>
        <v-col cols="12" sm="12">
          <v-slide-group
            v-model="model"
            class="pa-4"
            active-class="success"
            show-arrows
          >
            <v-slide-item v-for="(offer, index) in offers" :key="index">
              <v-card class="ma-4" height="300" width="300" color="grey">
                <v-img
                  :src="offer.thumb != '' ? offer.thumb : productPlaceholder"
                  class="white--text align-end addToWishlist"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="300px"
                  @click="viewProduct(offer.id)"
                >
                  <span class="red white--text offer-label">50%</span>
                  <div class="product-info">
                    <p
                      class="text-center card-title addToWishlist"
                      @click="viewProduct(offer.id)"
                    >
                      {{ offer.name }}
                    </p>

                    <v-row class="mx-0 text-center">
                      <v-col cols="2" sm="2" @click.stop="addToCart(offer.id)">
                        <v-icon color="#ffffff">add_shopping_cart</v-icon>
                      </v-col>
                      <v-col cols="8" sm="8">
                        <v-icon color="#FDCD25">star_rate</v-icon>
                        <v-icon color="#FDCD25">star_rate</v-icon>
                        <v-icon color="#FDCD25">star_rate</v-icon>
                        <v-icon color="#FDCD25">star_rate</v-icon>
                        <v-icon color="#FDCD25">star_rate</v-icon>
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        v-if="isLoggedIn"
                        @click.stop="addToWishList(offer.id)"
                      >
                        <v-icon color="#FDCD25" class="addToWishlist"
                          >favorite_border</v-icon
                        >
                      </v-col>
                    </v-row>
                  </div>
                </v-img>
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>

      <v-row class="margin-top bestSelling">
        <v-col cols="6" sm="6">
          <h2 class="main-color">{{ $t("mostSellingItems") }}</h2>
        </v-col>
        <v-col cols="6" sm="6">
          <p
            class="watchAll grey--text"
            :class="locale == 'en' ? 'text-right' : 'text-left'"
          >
            {{ $t("watchAll") }}
          </p>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="3"
          class="card-item"
          v-for="(product, index) in bestSellerProducts"
          :key="index"
        >
          <v-card class="mx-auto" max-width="374">
            <template slot="progress">
              <v-progress-linear
                color="deep-purple"
                height="10"
                indeterminate
              ></v-progress-linear>
            </template>

            <v-img
              height="250"
              class="addToWishlist"
              :src="product.thumb != '' ? product.thumb : productPlaceholder"
              @click="viewProduct(product.id)"
            ></v-img>

            <v-card-subtitle
              class="text-center main-color subtitle addToWishlist"
              @click="viewProduct(product.id)"
              >{{ product.name }}</v-card-subtitle
            >

            <v-card-text>
              <v-row class="mx-0 text-center">
                <v-col cols="2" sm="2">
                  <v-btn icon @click.stop="addToCart(product.id)">
                    <v-icon color="#FDCD25">add_shopping_cart</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="8" sm="8">
                  <v-icon color="#FDCD25">star_rate</v-icon>
                  <v-icon color="#FDCD25">star_rate</v-icon>
                  <v-icon color="#FDCD25">star_rate</v-icon>
                  <v-icon color="#FDCD25">star_rate</v-icon>
                  <v-icon color="#FDCD25">star_rate</v-icon>
                </v-col>
                <v-col
                  cols="2"
                  sm="2"
                  v-if="isLoggedIn"
                  @click.stop="addToWishList(product.id)"
                >
                  <v-icon color="#FDCD25" class="addToWishlist"
                    >favorite_border</v-icon
                  >
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider class="mx-4"></v-divider>
          </v-card>
        </v-col>
      </v-row>

      <!-- =========================most sale items=====================  -->
      <!-- <v-row class="products">
        <v-col cols="6" sm="6">
          <h2 class="main-color">{{ $t("mostSellingItems") }}</h2>
        </v-col>
        <v-col cols="6" sm="6">
          <p
            class="watchAll grey--text"
            :class="locale == 'en' ? 'text-right' : 'text-left'"
          >
            {{ $t("watchAll") }}
          </p>
        </v-col>
        <v-col cols="12" sm="12">
          <v-slide-group
            v-model="model"
            class="pa-4"
            active-class="success"
            show-arrows
          >
            <v-slide-item v-for="n in 15" :key="n">
              <v-card class="ma-4" height="300" width="300" color="grey">
                <v-img
                  src="../../assets/images/book.png"
                  class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="300px"
                >
                  <div class="product-info">
                    <p class="text-center card-title">امير البحار</p>

                    <v-row class="mx-0 text-center">
                      <v-col cols="2" sm="2">
                        <v-icon color="#FDCD25">add_shopping_cart</v-icon>
                      </v-col>
                      <v-col cols="8" sm="8">
                        <v-icon color="#FDCD25">star_rate</v-icon>
                        <v-icon color="#FDCD25">star_rate</v-icon>
                        <v-icon color="#FDCD25">star_rate</v-icon>
                        <v-icon color="#FDCD25">star_rate</v-icon>
                        <v-icon color="#FDCD25">star_rate</v-icon>
                      </v-col>
                      <v-col cols="2" sm="2">
                        <v-icon color="#FDCD25">favorite_border</v-icon>
                      </v-col>
                    </v-row>
                  </div>
                </v-img>
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row> -->
      <!-- =========================most recent items=====================  -->
      <v-row class="products">
        <v-col cols="6" sm="6">
          <h2 class="main-color">{{ $t("mostRecentItems") }}</h2>
        </v-col>
        <v-col cols="6" sm="6">
          <p
            class="watchAll grey--text"
            :class="locale == 'en' ? 'text-right' : 'text-left'"
          >
            {{ $t("watchAll") }}
          </p>
        </v-col>

        <v-col cols="12" sm="12">
          <v-slide-group
            v-model="model"
            class="pa-4"
            active-class="success"
            show-arrows
          >
            <v-slide-item
              v-for="(product, index) in latestProducts"
              :key="index"
            >
              <v-card class="ma-4" height="300" width="300" color="grey">
                <v-img
                  :src="
                    product.thumb != '' ? product.thumb : productPlaceholder
                  "
                  class="white--text align-end addToWishlist"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="300px"
                  @click="viewProduct(product.id)"
                >
                  <div class="product-info">
                    <p
                      class="text-center card-title addToWishlist"
                      @click="viewProduct(product.id)"
                    >
                      {{ product.name }}
                    </p>

                    <v-row class="mx-0 text-center">
                      <v-col
                        cols="2"
                        sm="2"
                        @click.stop="addToCart(product.id)"
                      >
                        <v-icon color="#FDCD25">add_shopping_cart</v-icon>
                      </v-col>
                      <v-col cols="8" sm="8">
                        <v-icon color="#FDCD25">star_rate</v-icon>
                        <v-icon color="#FDCD25">star_rate</v-icon>
                        <v-icon color="#FDCD25">star_rate</v-icon>
                        <v-icon color="#FDCD25">star_rate</v-icon>
                        <v-icon color="#FDCD25">star_rate</v-icon>
                      </v-col>
                      <v-col
                        cols="2"
                        sm="2"
                        v-if="isLoggedIn"
                        @click.stop="addToWishList(product.id)"
                      >
                        <v-icon class="addToWishlist" color="#FDCD25"
                          >favorite_border</v-icon
                        >
                      </v-col>
                    </v-row>
                  </div>
                </v-img>
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
    </v-container>

    <!-- ============================== sign up to educational platform ========================= -->
    <!-- signup -->
    <section class="signupSection" v-if="!teacherOrStudent">
      <v-container>
        <v-row>
          <v-col cols="12">
            <h2 class="section-title text-center white--text">
              {{ $t("createAccount") }}
            </h2>
          </v-col>

          <v-col cols="8" sm="8" md="8" offset="2">
            <v-row>
              <v-col>
                <div class="btns text-center">
                  <v-btn
                    class="primary-btn btn-rounded"
                    large
                    router
                    :class="
                      locale == 'en' ? 'btn-with-icon' : 'btn-with-icon-rtl'
                    "
                    to="/studentsignup"
                  >
                    <img
                      src="../../assets/images/student.png"
                      width="50px"
                      class="student-icon img-icon "
                    />
                    <span class="btn-content">
                      {{ $t("IAMStudent") }}
                    </span>
                  </v-btn>

                  <v-btn
                    class="second-btn  btn-with-icon btn-rounded"
                    large
                    router
                    :class="
                      locale == 'en' ? 'btn-with-icon' : 'btn-with-icon-rtl'
                    "
                    to="/teachersignup"
                  >
                    <img
                      src="../../assets/images/teacher.png"
                      width="50px"
                      class="teacher-icon img-icon"
                    />
                    <span class="btn-content">
                      {{ $t("IAMTeacher") }}
                    </span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <Snack ref="snack"></Snack>
  </div>
</template>

<script>
import AUTH from "../../auth";
export default {
  name: "marketFront",

  data() {
    return {
      productPlaceholder: require("../../assets/images/book.png"),
      model: null,
      isLoggedIn:
        localStorage.isLoggedIn != undefined &&
        localStorage.isLoggedIn == "true"
          ? true
          : false,

      locale: localStorage.locale,
      items: [
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg"
        }
      ],
      colorClasses: ["yellow", "light-green", "pink", "orange", "dark-green"],
      categories: [],
      offers: [],
      bestSellerProducts: [],
      latestProducts: [],
      teacherOrStudent: AUTH.teacherOrStudent()
    };
  },
  methods: {
    onSwiper(swiper) {
      console.log(swiper);
    },
    onSlideChange() {
      console.log("slide change");
    },
    getCategories() {
      this.$http.get(this.getApiUrl + "/market/categories").then(response => {
        if (response.data.status.error == false) {
          this.categories = response.data.data;
        }
      });
    },
    getHomeData() {
      this.$http.get(this.getApiUrl + "/market").then(response => {
        if (response.data.status.error == false) {
          this.offers = response.data.data.offers;
          this.bestSellerProducts = response.data.data.best_seller_products;
          this.latestProducts = response.data.data.latest_products;
        }
      });
    },
    viewProduct(id) {
      this.$router.push({ path: "/market/product/" + id });
    },
    addToWishList(product_id) {
      this.$http
        .get(this.getApiUrl + "/market/wishlist/add/" + product_id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            this.$refs.snack.sendSuccessAlert(response.data.status.message);
          } else {
            this.$refs.snack.sendErrorAlert(response.data.status.message);
          }
        });
    },
    addToCart(id) {
      this.$http
        .post(
          this.getApiUrl + "/market/cart/add",
          {
            product_id: id,
            cartID:
              localStorage.cartID && localStorage.cartID != undefined
                ? localStorage.cartID
                : ""
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale
            }
          }
        )
        .then(response => {
          if (response.data.status.error == false) {
            this.$refs.snack.sendSuccessAlert(response.data.status.message);
            if (response.data.data.cartID != undefined) {
              localStorage.cartID = response.data.data.cartID;
            }
            this.$bus.$emit("cartChanged");
          } else {
            this.$refs.snack.sendErrorAlert(response.data.status.message);
          }
        });
    }
  },
  mounted() {
    this.getCategories();
    this.getHomeData();
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";

.categories {
  .cat {
    // background-image: url("../../assets/images/School-Uniform.png");
    // background-position: center;
    // background-size: cover;
    // background-repeat: no-repeat;

    .category-link {
      text-decoration: none !important;
      color: #fff !important;
    }
    position: relative;
    margin: 0 auto;
    // height: 6rem;
    max-width: 90%;

    color: #ffffff;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 20px;
    border-radius: 75px;
    p {
      font-size: 1.3rem !important;
      font-weight: bold;
      margin: 0 !important;
    }
  }
}

.card-item {
  .subtitle {
    font-size: 1.2rem;
    color: $main-color;
  }
}

.margin-top {
  margin-top: 2rem;
}

/* products */
.products {
  margin-top: $margin-top;

  .card-title {
    margin-bottom: 0;
  }
  .product {
    position: relative;
    // max-width: 90% !important;

    img {
      max-width: 100% !important;
      margin: 0 auto;
      width: 100%;
    }
    .product-info {
      background-color: $home-overlay;
      width: 100% !important;
      color: #ffffff;
      // opacity: 0.8;
      text-align: center !important;
      position: absolute;
      bottom: 6px;
      p {
        margin-bottom: 2px;
      }
      .v-icon {
        font-size: larger !important;
      }
    }
  }
}

.ads {
  margin-top: 0 !important;
  .offer-label {
    display: inline-block;
    position: absolute;
    top: 2rem;
    right: 1rem;
    padding: 5px 5px;
    border-radius: 5px;
  }
}
.offers {
  .offer-label {
    display: inline-block;
    position: absolute;
    top: 2rem;
    right: 1rem;
    padding: 5px 5px;
    border-radius: 5px;
  }
}
.yellow {
  background-color: #ffc382 !important;
  opacity: 0.8;
}
.light-green {
  background-color: #13a8b1 !important;
  opacity: 0.8;
}
.pink {
  background-color: #fda5a5 !important;
  opacity: 0.8;
}
.orange {
  background-color: #d95e0a !important;
  opacity: 0.8;
}
.dark-green {
  background-color: #187e89 !important;
  opacity: 0.8;
}
.dark-red {
  background-color: #800000 !important;
  opacity: 0.8;
}

/* signupSection */
.signupSection {
  min-height: 25rem;
  background-image: url("../../assets/images/signup-section.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  position: relative;

  .btn-with-icon {
    width: 16rem;
    .img-icon {
      position: absolute;
      left: 0;
      bottom: -10px;
      margin-bottom: 0 !important;
    }
    .btn-content {
      margin-left: 4rem;
      display: inline-block;
    }
  }
  .btn-with-icon-rtl {
    width: 16rem;
    .img-icon {
      position: absolute;
      right: 0;
      bottom: -10px;
      margin-bottom: 0 !important;
    }
    .btn-content {
      margin-right: 4rem;
      display: inline-block;
    }
  }

  .section-title {
    margin-top: 2rem !important;

    color: #ffffff !important;
    margin-bottom: 3rem;
  }

  .btns {
    .teacher-icon {
      margin-bottom: 100%;
    }
    .student-icon {
    }
    .v-btn {
      border-color: #ffffff;
      color: #ffffff !important;
    }
  }

  @media (min-width: 600px) {
    .btns {
      .v-btn {
        margin: 20px !important;
      }
    }
  }
}

.theme--light.v-chip {
  text-align: center;
  min-width: 9rem;
  display: inline;
  color: #ffffff !important;
  font-size: 1.2rem;
}

.v-divider {
  max-height: 10px !important;
  height: 10px !important;
}
.addToWishlist {
  cursor: pointer;
}

.nav-link {
  color: gray !important;
  text-decoration: none !important;
}
</style>
